import Vue from 'vue';
import Component from 'vue-class-component';

import ProductsFiltersQuery from 'assets/graphql/queries/ProductsFilters.graphql';
import OrderDropdown from 'components/OrderDropdown/OrderDropdown.vue';
import CustomLandingFiltersBarComponent from 'components/CustomLanding/CustomLandingFiltersBar/CustomLandingFiltersBar.vue';
import ExperienceBox from 'components/ExperienceBox';
import SpinnerLoading from 'common/components/SpinnerLoading';
import BbModal from 'common/components/BbModal/BbModal.vue';
import CustomLandingFilters from 'components/CustomLanding/CustomLandingFilters/CustomLandingFilters.vue';
import filterIcon from 'common/icons/FilterPrimary.png';
import closeIcon from 'common/icons/Close.svg';
import { isNumber } from 'lodash';
import { getPaginatedActivities } from 'services/paginatedActivities.service.js';
import { Watch } from 'vue-property-decorator';
import BoxCard from 'common/components/BoxCard';
@Component({
  components: {
    BoxCard,
    ExperienceBox,
    CustomLandingFiltersBarComponent,
    OrderDropdown,
    SpinnerLoading,
    BbModal,
    CustomLandingFilters,
  },
  props: {
    landing: {
      type: Object,
      required: true,
    },
  },
  apollo: {
    productsFilters: {
      query: ProductsFiltersQuery,
      variables() {
        return {
          filters: {
            landing_slug: this.$route.params.landingSlug,
            categories: true,
            participants: true,
            provinces: true,
            price_range: true,
          },
        };
      },
      update(response) {
        const filters = response.products_filters
          .map(item => {
            return JSON.parse(item);
          })
          .filter(el => Object.keys(el).length);
        const activeQueries = this.$route.query;

        filters.forEach(filter => {
          if (Object.keys(activeQueries).includes(filter.name)) {
            filter.options.forEach(value => {
              value.active = activeQueries[filter.name].includes(value.name);
            });
          }
        });
        this.filters = filters;
        return filters;
      },
    },
  },
})
export default class CustomLandingActivitiesComponent extends Vue {
  activePage = 1;
  totalPages = 0;
  activitiesOrder = 'discount';
  selectedValues = {};
  currentTags = [];
  activitiesDiscount = [];
  showOptionDiscount = false;
  activities = {
    results: [],
    total: 0,
  };
  filters = {};
  showBackgroundFilter = false;
  selectedOption = '';
  selectedFilter = null;
  hasNextPage = false;
  sortOption = '';
  firstLoad = true;
  modalOpened = false;
  filter = {
    landing_slug: this.$route.params.landingSlug,
    category: null,
    participants: null,
    province: null,
    price_range: null,
  };
  priceRange = [];
  filterList = [];
  icons = {
    filterIcon,
    closeIcon,
  };
  landingSlug = '';
  loading = false;

  orderOptions = [
    { title: 'más nuevas', value: 'newer' },
    { title: 'menor precio', value: 'lower_price' },
    { title: 'mayor precio', value: 'higher_price' },
    this.landing.show_percentage
      ? { title: 'mayor descuento', value: 'discounted_percentage' }
      : false,
  ];

  async mounted() {
    await this.fetchInitialActivities();
  }

  async fetchInitialActivities() {
    this.loading = true;
    const page_config = {
      page_number: 1,
      per_page: 12,
    };

    const filters = JSON.stringify({
      ...this.filter,
    });

    const { response } = await getPaginatedActivities(
      null,
      page_config,
      filters,
      this.sortOption,
    );
    const { results, page_info } = response;

    this.hasNextPage = page_info.has_next;
    this.initialDataLoaded = true;
    this.activities.results = results;
    this.activities.total = page_info.count;
    this.totalPages = page_info.num_pages;
    this.landingSlug = this.$route.params.landingSlug,

    this.loading = false;
  }

  async updateFilter({ filter, option, sort }) {
    this.sortOption = sort;
    this.activePage = 1;
    this.activities.results = [];
    switch (filter) {
      case 'province':
        this.selectedFilter = filter;
        this.selectedOption = option;
        this.selectedValues.province = option.toString();
        await this.fetchMoreActivities();
        break;
      case 'category':
        this.selectedFilter = filter;
        this.selectedOption = option;
        this.selectedValues.category = option;
        await this.fetchMoreActivities();
        break;
      case 'participants':
        this.selectedFilter = filter;
        this.selectedOption = option;
        this.selectedValues.participants = option;
        await this.fetchMoreActivities();
        break;
      case 'price_range':
        this.selectedFilter = filter;
        this.selectedOption = option;
        this.selectedValues.price_range = option;
        await this.fetchMoreActivities();
        break;
      case 'sort':
        this.sortOption = sort;
        await this.refetchActivities();
        break;
      //Default: reset filters
      default:
        this.selectedFilter = '';
        this.selectedOption = '';
        this.selectedValues = {};
        await this.fetchMoreActivities();
        break;
    }
  }

  async refetchActivities(filters = []) {
    filters.map(item => {
      this.filter[item.key] = isNumber(item.value)
        ? String(item.value)
        : item.value;
    });

    await this.fetchInitialActivities();
  }

  toggleBackgroundFilter(flag) {
    this.showBackgroundFilter = flag;
  }

  async fetchMoreActivities() {
    this.firstLoad = false;
    this.loading = true;
    this.activePage += 1;

    const page_config = {
      page_number: this.activePage,
      per_page: 12,
    };
    const filters = JSON.stringify({
      ...this.filter,
    });

    const { response } = await getPaginatedActivities(
      null,
      page_config,
      filters,
      this.sortOption,
    );
    const { results, page_info } = response;

    this.activities.results = this.activities.results.concat(results);
    this.hasNextPage = page_info.has_next;
    this.activities.total = page_info.count;
    this.totalPages = page_info.num_pages;

    this.loading = false;
  }

  /**
   * Resert selectedValues and activityList to the starting values
   */
  async resetFilter() {
    this.selectedValues = null;
  }

  deleteFilter(filterDelete) {
    // delete the filter in the filterList
    this.removeFilter(filterDelete.value);
    // deactivate the filter in the filter options
    this.filters.map(filter => {
      if (filter.name === 'price_range') {
        filter.options.map(option => {
          option.name = null;
        });
      }
      if (
        filterDelete.key === 'category' ||
        filterDelete.key === 'participants'
      ) {
        filter.options.map(option => {
          if (String(option.name) === filterDelete.value[0]) {
            option.active = !option.active;
          }
        });
      }
      if (filterDelete.key === 'province') {
        filter.options.map(option => {
          if (option.name === Number(filterDelete.value[0])) {
            option.active = !option.active;
          }
        });
      }
      // update the filter and refetch the activities
      this.filter[filterDelete.key] = null;
      this.refetchActivities(this.filterList);
    });
  }

  removeFilter(value) {
    const index = this.filterList.map(f => f.value).indexOf(value);
    this.filterList.splice(index, 1);
  }

  filterSelected(value, title, active, key) {
    if (!active) {
      this.removeFilter(value);
      return;
    }
    this.filterList.map(filter => {
      if (filter.key === key) {
        this.removeFilter(filter.value);
      }
    });
    if (key === 'price_range') {
      if (value.split('=')[0] === 'min_price') {
        this.priceRange[0] = value;
      }
      this.priceRange[1] = value;
    }

    value = [`${value}`];

    this.filterList = [
      {
        value: key === 'price_range' ? this.priceRange : value,
        title,
        key,
      },
      ...this.filterList,
    ];
  }

  changeFilters(key, value) {
    this.filters.map(filter => {
      if (filter.name !== key) return;

      if (key === 'price_range') {
        filter.options.map(option => {
          option.active = true;
          if (option.name === null) {
            option.name = 0;
          }
          this.filterSelected(
            `${option.title}=${option.name}`,
            option.title,
            option.active,
            key,
          );
        });
        return;
      }

      filter.options.map(option => {
        if (option.name === value) {
          option.active = !option.active;
          this.filterSelected(option.name, option.title, option.active, key);
          return;
        }
        option.active = false;
      });
      return;
    });
  }

  disableScroll() {
    let y = window.scrollY;
    window.onscroll = () => {
      window.scrollTo(0, y);
    };
  }

  enableScroll() {
    window.onscroll = () => {};
  }

  applyFilters() {
    this.refetchActivities(this.filterList);
    this.closeModal();
  }

  openModal() {
    this.modalOpened = true;
    this.disableScroll();
  }

  closeModal() {
    this.modalOpened = false;
  }

  @Watch('modalOpened')
  enableScrollOnModalClose(newVal, oldVal) {
    if (newVal === false && oldVal === true) {
      this.enableScroll();
    }
  }
}
